import { GatewaysAuthPage } from "./gateways/GatewaysAuth";

export const AuthAzurePage = GatewaysAuthPage;
